























import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { OnboardingBalanceTransfer } from "@/employee/route-names";
import { useThemeStore } from "@/shared/store/theme";
import UpfrontContributionBase from "@/employee/components/onboarding/upfront-contribution/UpfrontContributionBase.vue";

@Component({
  components: {
    UpfrontContributionBase,
    Button
  }
})
export default class OnboardingContributionScheduledMessage extends Vue {
  themeStore = useThemeStore();

  onContinue () {
    this.$router.push({
      name: OnboardingBalanceTransfer
    });
  }
}
